import React, { Component, PropTypes } from "react";

import styled from "styled-components";

const Progress = styled.div`
height: 26px;
width: 100%;
position:relative;
border-radius:100px;
background-color: ${props => props.theme.color.white};
box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);
&:after {
    content:'';
    position:absolute;
    background:${props => props.theme.color[props.variant]};
    border-bottom-left-radius: 20px;
    border-top-left-radius: 20px;
    border-top-right-radius: ${props => (props.fillPercentWidth > 97 ? 20 : 0)}px;
    border-bottom-right-radius: ${props => (props.fillPercentWidth > 97 ? 20 : 0)}px;
    top:0; bottom:0;
    left:0; 
    width:${props => props.fillPercentWidth}%;
    -webkit-animation: filler 2s ease-in-out;
    -moz-animation: filler 2s ease-in-out;
    animation: filler 2s ease-in-out;
    height: 26px;
    opacity:${props => props.opacity}
}

@-webkit-keyframes filler {
    0% {
        width:0;
        height:1;
    }
}
@-moz-keyframes filler {
    0% {
        width:0;
        height:1;
    }
}
@keyframes filler {
    0% {
        width:0;
        height:1;
    }
}

`;

const ProgressContainer = styled.section`

`;

const ProgressMeter = props => {
    const { variant, fillPercentWidth, opacity } = props;
    return (
        <Progress
            variant={variant}
            fillPercentWidth={fillPercentWidth}
            opacity={opacity}
        />
    );
};

ProgressMeter.propTypes = {
    variant: PropTypes.string,
    fillPercentWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    opacity: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

ProgressMeter.defaultProps = {
    opacity: 1
};

export default ProgressMeter;



// WEBPACK FOOTER //
// ./src/components/comparison/ProgressMeter.js